import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import GSTRepo from './Sales/GSTR-1_Repository/GSTRepo';
import Gst2aRepository from './Purchase/GSTR-2A_Repository/Gst2aRepository';
import Gstr2bRepository from './Purchase/GSTR2B_Repository/Gstr2bRepository';
import Gstr3bRepository from './Purchase/GSTR-3B-Repository/Gstr3bRepositry';
import Gstr8ARepository from './Purchase/Gstr-8A_Repository/Gstr-8A_Repositery';
import Form26as from "./Sales/Form26as/form26asRepo";
// import AisUpload from "../AIS/AisUpload";
import EInvoiceRepository from './Sales/E_Invoice_Repository/e_invoice_repo';
import IMSRepository from './Purchase/IMS_Repository/ImsRepository';
// import IMSRepositoryOutward from './Sales/IMS-Repository/ImsRepositoryOutward';
import Gst2aStatus from './Purchase/GSTR-2A_Reconciliation/Gst2aStatus';
import TDSChallanRepository from './Purchase/TDSChallanRepository/tds_challan_repo';
// import GSTR1ARepo from './Sales/GSTR-1A_Repository/gstr1a_repo';
// import GSTRepositoryMain from './Sales/GSTR-1_Repository/GSTRepositoryMain';
import DescriptionIcon from '@mui/icons-material/Description';
import Gstr6aRepository from "./Purchase/GSTR6A_Repository/Gstr6aRepository";
export default function RepoCards() {
    const history = useHistory();
    const location = useLocation();

    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    // const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    // const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];
    //  const allThreeRepoAvailable =
    //     salesAccess.includes("GSTR1-RECONCILLATION") ||
    //     purchaseAccess.includes("GSTR2A-RECONCILLATION") ||
    //     purchaseAccess.includes("GSTR2B-RECONCILLATION");
    const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];
    const allThreeRepoAvailable =
        salesAccess.includes("GSTR1-REPOSITORY") ||
        purchaseAccess.includes("GSTR2A-REPOSITORY") ||
        purchaseAccess.includes("GSTR2B-REPOSITORY");


    const gstRepoOptions = [
        // allThreeRepoAvailable && {
        //     label: 'GST Repo',
        //     icon: <DescriptionIcon />,
        //     path: '/GSTRepositoryMain',
        //     component: GSTRepositoryMain
        // },
        salesAccess.includes("GSTR1-REPOSITORY") && {
            label: 'GSTR-1',
            path: '/GSTRepo',
            component: GSTRepo
        },
        // salesAccess.includes("GSTR1-RECONCILLATION") && {
        //     label: 'GSTR-1A',
        //     path: '/GSTR1ARepo',
        //     component: GSTR1ARepo
        // },
        purchaseAccess.includes("GSTR2A-REPOSITORY") && {
            label: 'GSTR-2A',
            path: '/Gst2aRepository',
            component: Gst2aRepository
        },
        purchaseAccess.includes("GSTR2B-REPOSITORY") && {
            label: 'GSTR-2B',
            path: '/Gstr2bRepository',
            component: Gstr2bRepository
        },
          purchaseAccess.includes("GSTR6A-REPOSITORY") && {
      label: "GSTR-6A",
      path: "/Gstr6aRepository",
      component: Gstr6aRepository,
        },
        purchaseAccess.includes("GSTR3B") && {
            label: 'GSTR-3B',
            path: '/GSTR_3B_Repository',
            component: Gstr3bRepository
        },
        (sitemapData?.["GSTR-9 RECONCILIATION"]?.['GSTR-9']?.includes("GSTR-9 RECONCILIATION")) && {
            label: 'GSTR-8A',
            path: '/Gstr8aRepository',
            component: Gstr8ARepository
        },
        // purchaseAccess.includes("GSTR2-PREVALIDATION") && {
        //     label: 'GSTR-STATUS',
        //     path: '/Gst2aStaus',
        //     component: Gst2aStatus
        // },
        salesAccess.includes("E-INVOICE RECONCILIATION") && {
            label: 'E-Invoice',
            path: '/E-InvoiceRepo',
            component: EInvoiceRepository
        },
        purchaseAccess.includes("IMS-REPOSITORY") && {
            label: 'IMS INWARD',
            path: '/IMSRepo',
            component: IMSRepository
        },
        // salesAccess.includes("IMS OUTWARD REPOSITORY") && {
        //     label: 'IMS OUTWARD',
        //     path: '/IMSRepoOutward',
        //     component: IMSRepositoryOutward
        // },
    ].filter(Boolean);

    const tdsRepoOptions = [
        (salesAccess.includes("26AS-TDS-REPOSITORY") && (localStorage.getItem("show_recon") != "N")) && {
            label: '26AS-TDS',
            path: '/TDSRepo',
            component: Form26as
        },
        (salesAccess.includes("26AS-TDS-REPOSITORY") && (localStorage.getItem("show_recon") != "N")) && {
            label: '26AS-TCS',
            path: '/TDSRepo',
            component: Form26as
        },
        purchaseAccess.includes("TDS PAYABLE RECONCILLATION") && {
            label: 'TDS Challan',
            path: '/TDSChallanRepository',
            component: TDSChallanRepository
        },
        // purchaseAccess.includes("AIS REPOSITORY") && {
        //     label: 'AIS',
        //     path: '/AisUpload',
        //     component: AisUpload
        // }
    ].filter(Boolean);

    const activeTab = [...gstRepoOptions, ...tdsRepoOptions].find(tab => tab.path === location.pathname);
    const ActiveComponent = activeTab?.component;

    const handleCardClick = (report) => {
        history.push(report.path);
    };

    return (
        <Box sx={{
            fontFamily: "'Inter', sans-serif",
            width: '100%',
            minHeight: '100vh',
            background: 'linear-gradient(to bottom, #e8eef5 0%, #f5f7fa 100%)',
            p: 0
        }}>
            {ActiveComponent ? (
                <ActiveComponent />
            ) : (
                <>
                    {/* Page Heading */}
                    <Box sx={{
                        textAlign: 'center',
                        pt: 3,
                        pb: 0.5
                    }}>
                        <Box sx={{
                            fontSize: '38px',
                            fontWeight: 900,
                            color: '#03406d',
                            letterSpacing: '2px',
                            fontFamily: '"Dosis", sans-serif',
                            textTransform: 'uppercase'
                        }}>
                            REPOSITORY
                        </Box>
                    </Box>
                    
                    {(gstRepoOptions.length > 0 && tdsRepoOptions.length > 0) ? (
                    <Box sx={{
                        display: 'flex',
                        gap: 3,
                        p: 4,
                        width: '100%'
                    }}>
                        {/* GST Module */}
                        <Box sx={{
                            flex: 1,
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    GST MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2.5
                                }}>
                                    {gstRepoOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>

                        {/* TDS Module */}
                        <Box sx={{
                            flex: 1,
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    TDS MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 2.5
                                }}>
                                    {tdsRepoOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : gstRepoOptions.length > 0 ? (
                    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{
                            maxWidth: '900px',
                            width: '100%',
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    GST MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 2.5
                                }}>
                                    {gstRepoOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : tdsRepoOptions.length > 0 ? (
                    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{
                            maxWidth: '900px',
                            width: '100%',
                            background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            border: '3px solid #03406d',
                            boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)'
                        }}>
                            <Box sx={{
                                background: '#03406d',
                                p: 2,
                                mb: 2
                            }}>
                                <Box sx={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    letterSpacing: '1px'
                                }}>
                                    TDS MODULE
                                </Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 2.5
                                }}>
                                    {tdsRepoOptions.map((report, index) => (
                                        <Box
                                            key={index}
                                            onClick={() => handleCardClick(report)}
                                            sx={{
                                                background: '#ffffff',
                                                borderRadius: '12px',
                                                p: 3,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                minHeight: '80px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderLeft: '5px solid #03406d',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    height: '100%',
                                                    width: '5px',
                                                    background: '#03406d',
                                                    transition: 'width 0.4s ease',
                                                    zIndex: 0
                                                },
                                                '&:hover': {
                                                    transform: 'translateY(-4px)',
                                                    boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
                                                    '& > div': {
                                                        color: '#ffffff'
                                                    }
                                                },
                                                '&:hover::before': {
                                                    width: '100%'
                                                }
                                            }}
                                        >
                                            <Box sx={{
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: '#212121',
                                                textAlign: 'center',
                                                position: 'relative',
                                                zIndex: 1,
                                                transition: 'color 0.3s ease',
                                            }}>
                                                {report.label}
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Box sx={{
                        textAlign: 'center',
                        mt: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                        <Box sx={{ fontSize: '18px', color: '#607d8b' }}>
                            Please activate the Repository Services to access.
                        </Box>
                    </Box>
                )}
                </>
            )}
        </Box>
    );
}